export const PasswordPattern =
	/^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/;

export const PersianNumberPattern = /[۰۱۲۳۴۵۶۷۸۹]+/;

export const OnlyPersianCharactersPattern =
	/^[كي آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/;

export const OnlyEnglishCharactersPattern = /^[A-Za-z]+$/;

export const CellphonePattern = /^09[0-9]{9}$/;

export const NationalCodePattern = /^[0-9]{10}$/;

export const CertificateSeriPattern = /^[0-9]{5,6}$/;

export const CertificateSeriCharPattern =
	/^[كيآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]{1,6}$/;

export const CertificateNoPattern = /^[0-9]{1,10}$/;

export const NumericPattern = /^([0-9])*$/;

export const UserNamePattern =
	/^([-]|[_]|[a-zA-Z0-9]|[.]|[@]|[$]|[%]|[!]){5,40}$/;

export const PostCodePattern = /^([1-9][0-9]{9})$/g;

export const checkPostCodePattern = (data) => {
    let patternID = /^([1-9][0-9]{9})$/g;
    let newVal = patternID.test(data);
    if(newVal === false) {
        return false;
    }
    return true
}


export const CertificateSeriNoPattern = /^[0-9]{0,2}$/;

export const PhonePattern = /^0[1-9][0-9]{9}$/;

export const EmailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+$/;

export const SocialNetworkPattern = /^[a-zA-Z0-9_.@-]+$/;

export const FaxPattern = /^0[1-9][0-9]{9}$/;

export const EnglishNumberPattern = /^[0-9]+$/;

export const ValidNamePattern =
	/^[كي آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیA-Za-z]+$/;

export const ValidCharactersPattern =
	/^[كي آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیA-Za-z0-9]+$/;

export const ValidAddressPattern =
	/^[كي آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیA-Za-z0-9 ._-]+$/;

export const PUBLIC_PATTERN =
	/^([a-zA-Z]|[ء-ٞ]|[پ]|[چ]|[ژ]|[ک]|[گ]|[ی]|[ۀ]|[?]|[ ]|[-]|[_]|[0-9]|[!]|[@]|[#]|[$]|[%]|[^]|[&]|[*]|[(]|[)]|[+]|[=]|[.]|[,]|[<]|[>]|[,]|[/]|[?]|[\\]|[|]|[{]|[}]|[[]|[]]|[٠]|[١]|[٢]|[٣]|[٤]|[٥]|[٦]|[٧]|[٨]|[٩]|[۰]|[۱]|[۲]|[۳]|[۴]|[۵]|[۶]|[۷]|[۸]|[۹]|[\r]|[\n]|[\t])*$/g;

export const ValidUserNameCharacters =
	/abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_.@-/;
